
import { DrillsRepository } from "../../../infra/repository/drills.repository";
import { Drill } from "../../domain/drill";

export class ListDrillsUseCase {
    static async execute(): Promise<Drill[]> {
        try {
            const response = await DrillsRepository.list();
            if (response.error) return [];
            return response.data;
        } catch (error) {
            return [];
        }
    }
}
